<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-card>
            <v-card-title id="heading" class="bg-white position-fixed w-100 z-index-9">
                <div class="d-flex justify-space-between">
                    <h4>"{{ vehicleModel.name }}" Service Types</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </div>
            </v-card-title>

            <v-container class="mt-10 mb-5">
                <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                         density="compact" variant="tonal">
                    <p v-for="error in errors">{{ error }}</p>
                </v-alert>

                <v-row>
                    <v-col cols="12">
                        <v-btn color="black"
                               variant="flat"
                               @click="selectAllServiceTypes">Select All
                        </v-btn>
                    </v-col>
                    <v-col v-for="serviceType in serviceTypes" class="py-0" cols="4">
                        <v-switch v-model="selectedServiceTypes" :label="`${serviceType.name}`"
                                  :value="serviceType.id"
                                  color="primary"
                                  density="compact"/>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions class="px-4 bg-white position-fixed w-100 z-index-9 bottom-0">
                <div class="d-flex justify-end">
                    <v-btn :disabled="!selectedServiceTypes.length" color="primary" size="small"
                           @click="updateServiceTypes">
                        Save
                    </v-btn>
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {ref, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const {showSnackbar} = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    type: Number,
    vehicleModel: {
        type: Object
    }
});

const emits = defineEmits(['update:modelValue']);
const dialogSwitch = ref(props.modelValue);
const selectedServiceTypes = ref([]);
const serviceTypes = ref([]);
const errors = ref([]);

onMounted(() => {
    fetchServiceTypes();
    fetchSelectedServiceTypes();
});
const selectAllServiceTypes = () => {
    if (serviceTypes.value.length) {
        serviceTypes.value.map((type) => selectedServiceTypes.value.push(type.id))
    }
}
const fetchServiceTypes = () => {
    send('get', `fleet/service-types`, {list: true, type: props.type})
        .then((response) => {
            serviceTypes.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Maintenance Service Types could not be loaded', 'error')
        })
}
const fetchSelectedServiceTypes = () => {
    send('get', `fleet/models/${props.vehicleModel.id}/service-types`, {'only-keys': true})
        .then((response) => {
            selectedServiceTypes.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Selected Maintenance Service Types could not be loaded', 'error')
        })
}
const updateServiceTypes = () => {
    errors.value = [];
    send('post', `fleet/models/service-types`, {
        model: props.vehicleModel.id,
        services: selectedServiceTypes.value
    })
        .then((response) => {
            showSnackbar(response.data.message);
            if (response.data.success) {
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>

<style scoped>
.z-index-9 {
    z-index: 9;
}
</style>
